import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from "react-intl";

import {styled} from "@mui/material/styles";

import {validationFieldLabelId} from "./validationFieldLabel";

const List = styled('ul')({
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
});

const Field = styled('span')({
    fontWeight: 700
});

ValidationErrorsTooltip.propTypes = {
    // {path, message} pairs, as carried by the Elasticsearch document
    errors: PropTypes.arrayOf(PropTypes.shape({
        // '' when the constraint is about the product / variation as a whole
        path: PropTypes.string,
        message: PropTypes.string,
    })).isRequired,
};

// Content of the tooltip anchored on the KO tag: one line per validation error, prefixed by
// the field it concerns. The message alone is not enough — "Cette valeur ne doit pas être
// vide." is NotBlank's default text and reads the same for sku, brand and description.
function ValidationErrorsTooltip({errors}) {
    const intl = useIntl();

    // An unknown path falls back to the raw path instead of being dropped: a new constraint
    // on the API side must never make an error vanish from the tooltip silently.
    const label = (path) => {
        const id = validationFieldLabelId(path);

        return intl.messages[id] ? intl.formatMessage({id}) : path;
    };

    return (
        <List>
            {errors.map(({path, message}) => (
                <li key={`${path} ${message}`}>
                    {path ? <><Field>{label(path)}</Field>{' : '}</> : null}
                    {message}
                </li>
            ))}
        </List>
    );
}

export default ValidationErrorsTooltip;
